export function getDeviceOs(): 'iOS' | 'Android' | 'Unknown' {
  if (/iPhone|iPad|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'iOS';
  }

  return /Android/i.test(navigator.userAgent) ? 'Android' : 'Unknown';
}
